import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'acmCutUnderscore',
})

/**
 * Get content from string HTML
 * @param html - string
 * @returns string - inner text
 */
export class AcmCutUnderscorePipe implements PipeTransform {

    transform(text: string): string {
        return text.replace(/_/g, ' ');
    }
}
